import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { merge } from 'rxjs';
import { faTwitter, faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

import { BroadcastService } from 'services/broadcast.service';
import { AuthService } from 'core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [FaIconComponent],
})
export class FooterComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly broadcastService = inject(BroadcastService);
  private readonly authService = inject(AuthService);

  faTwitter = faTwitter;
  faFacebook = faFacebookF;
  faLinkedin = faLinkedinIn;

  exchangeBlocked = false;
  currentYear: number = new Date().getFullYear();

  ngOnInit(): void {
    this.trackExchangeBlocked();

    // Don't need to clean up the subscriptions as the footer never goes away
    merge(this.broadcastService.logoutSource$, this.broadcastService.accountBlockedSource$).subscribe(() => this.trackExchangeBlocked());
  }

  private trackExchangeBlocked() {
    this.exchangeBlocked = this.authService.getLoggedInUserDetails()?.exchangeBlocked ?? false;
  }

  enableAccount(): void {
    this.router.navigateByUrl('settings');
    setTimeout(() => {
      this.broadcastService.broadcastEnableAccountChange();
    }, 100);
  }
}
